import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * useEffect with skipped onMount
 */
export const useOnChangeEffect = (
  func: EffectCallback,
  deps: DependencyList
) => {
  const firstMount = useRef(true);

  useEffect(() => {
    if (firstMount.current) {
      firstMount.current = false;
      return;
    }

    return func();
  }, deps);
};
